// import Loadable from "app/components/Loadable";
import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FeedCompanyList = Loadable(lazy(() => import("./FeedCompanyList")));
const FeedCompanyForm = Loadable(lazy(() => import("./FeedCompanyForm")));

const feedCompanyRoutes = [
  {
    path: "/FeedCompany/FeedCompanyList",
    element: <FeedCompanyList />,
  },
  {
    path: "/FeedCompany/FeedCompanyForm",
    element: <FeedCompanyForm />,
  },
  {
    path: "/FeedCompany/FeedCompanyForm/:feedCompanyId",
    element: <FeedCompanyForm />,
  },
];
export default feedCompanyRoutes;
